import React, { Component, createRef } from 'react'
import { withFirebase } from '../Fb'
import { Button, FormGroup, Label, Input, Spinner } from 'reactstrap'
import { Editor } from '@tinymce/tinymce-react'
import Alert from '@mui/material/Alert'

class MessageEditor extends Component {
  constructor(props) {
    super(props)
    this.editorRef = createRef(null)
    this.state = {
      body: '',
      subject: '',
    }
  }

  componentDidMount() {
    this.setState({
      body: this.props.body || '',
      subject: this.props.subject || '',
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.body !== prevProps.body) {
      this.setState({ body: this.props.body || '' })
    }
    if (this.props.subject !== prevProps.subject) {
      this.setState({ subject: this.props.subject || '' })
    }
  }

  onClose = () => {
    this.setState({ body: '', subject: '' }, this.props.onClose)
  }

  onCancel = () => {
    this.setState({ body: '', subject: '' }, this.props.onClose)
  }

  onSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(
        this.state.subject,
        this.editorRef.current.getContent({ format: 'html' }),
        this.editorRef.current.getContent({ format: 'text' })
      )
      // Only clear when the host actually closes the editor. Hosts that keep it mounted
      // (MessageListMessageDetails) pass no onClose, and clearing there blanked the
      // subject field after every save - componentDidUpdate cannot restore it because the
      // parent writes back the same subject, so its inequality guard never fires.
      if (this.props.onClose) {
        this.setState({ body: '', subject: '' }, this.props.onClose)
      }
    } else if (this.props.recipientids) {
      this.setState({ sending: true })
      // this.props.firebase
      //   .sendMessages(
      //     this.props.recipientids,
      //     this.state.subject,
      //     this.editorRef.current.getContent({ format: 'text' }),
      //     this.editorRef.current.getContent({ format: 'html' }),
      //     ['admin', 'activities']
      //   )
      //   .then(() => {
      //     this.setState({ body: '', subject: '', sending: false }, this.props.onClose)
      //   })
    } else {
      this.setState({ body: '', subject: '' }, this.props.onClose)
    }
  }

  // Reads the live editor content. TinyMCE is uncontrolled here (initialValue), so state
  // and the parent's copy of the html are both stale as soon as the user types - the ref
  // is the only source of truth. Deliberately does not clear state or close the editor.
  onSaveTemplate = () => {
    if (!this.props.onSaveTemplate) return
    const editor = this.editorRef.current
    if (!editor) return
    this.props.onSaveTemplate({
      subject: this.state.subject || '',
      html: editor.getContent({ format: 'html' }),
      text: editor.getContent({ format: 'text' }),
    })
  }

  handleMessageBodyChange = (body) => {
    this.setState({ body })
  }

  handleMessageSubjectChange = (e) => {
    this.setState({ subject: e.target.value })
  }

  render() {
    return (
      <>
        <FormGroup>
          <Label for='messageSubject'>Otsikko</Label>
          <Input
            id='messageSubject'
            value={this.state.subject}
            name='messageSubject'
            onChange={this.handleMessageSubjectChange}
          />
        </FormGroup>
        <Editor
          tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
          onInit={(evt, editor) => (this.editorRef.current = editor)}
          initialValue={this.state.body || ''}
          init={{
            height: 800,
            menubar: true,
            promotion: false,
            plugins: [
              'advlist',
              'autolink',
              'lists',
              'link',
              'image',
              'charmap',
              'anchor',
              'searchreplace',
              'visualblocks',
              'code',
              'fullscreen',
              'insertdatetime',
              'media',
              'table',
              'preview',
              'help',
              'wordcount',
            ],
            toolbar:
              'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
            content_style:
              'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            image_uploadtab: true,
            images_file_types: 'jpeg,jpg',
            images_upload_handler: (blobInfo) => {
              const base64str =
                'data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64()
              return Promise.resolve(base64str)
            },
          }}
        />
        <br />
        {/* <Alert severity='info'>
          Jos haluat, että henkilöt voivat vastata viestiin muista määritellä
          sähköposti viestiasetuksista.
        </Alert> */}
        {/* <Button color='secondary' onClick={this.onCancel} disabled={this.state.sending}>
            {'Peruuta'}
          </Button> */}
        <Button
          color='primary'
          onClick={this.onSubmit}
          disabled={this.state.sending}
        >
          {this.state.sending ? (
            <Spinner size={'sm'} />
          ) : (
            this.props.submitText || 'Lähetä'
          )}
        </Button>
        {/* Opt in: hosts that do not pass onSaveTemplate render exactly as before. */}
        {this.props.onSaveTemplate && (
          <Button
            color='secondary'
            outline
            className='ml-2'
            onClick={this.onSaveTemplate}
            disabled={this.state.sending || this.props.savingTemplate}
          >
            {this.props.savingTemplate ? <Spinner size={'sm'} /> : 'Tallenna mallipohjaksi'}
          </Button>
        )}
      </>
    )
  }
}

export default withFirebase(MessageEditor)
